// @ts-nocheck

import { fill } from 'lodash';
import React, { useMemo } from 'react';
import styled from 'styled-components';

const WIDTH_POINT = 4;

const Wrap = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${WIDTH_POINT + WIDTH_POINT * 2}px;
`;

const Move = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  position: absolute;
  left: calc(50% - 7px);
  transition: transform 300ms ease-out;
  transform: translateX(-${({ $offset }) => $offset * (WIDTH_POINT + WIDTH_POINT + WIDTH_POINT * 2)}px);
`;

const Point = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 ${WIDTH_POINT}px;
`;

const getColor = ({ $isFocus, $isRed, theme }) => {
  if ($isFocus) {
    if ($isRed) {
      return theme.grids.colors.redlight;
    }
    return theme.grids.colors.yellow;
  }
  return theme.grids.colors.lightgrey;
};

const HalfCircle = styled.div`
  display: inline-block;
  background-color: ${getColor};
  width: ${WIDTH_POINT}px;
  height: ${WIDTH_POINT * 2}px;
`;

const HalfCircleLeft = styled(HalfCircle)`
  border-bottom-left-radius: ${WIDTH_POINT * 2}px;
  border-top-left-radius: ${WIDTH_POINT * 2}px;
`;

const HalfCircleRight = styled(HalfCircle)`
  border-bottom-right-radius: ${WIDTH_POINT * 2}px;
  border-top-right-radius: ${WIDTH_POINT * 2}px;
`;

const MiddleExpand = styled.div`
  background-color: ${getColor};
  width: ${({ $isFocus }) => ($isFocus ? WIDTH_POINT * 2 : 0)}px;
  height: ${WIDTH_POINT * 2}px;
  transition: width 300ms ease-out;
`;

type Props = {
  current: number;
  length: number;
  className?: string;
  isRed?: boolean;
};

const SwipeReperes = ({ current, length, className, isRed = false }: Props) => {
  const countArray = useMemo(() => fill(Array(length), true), [length]);
  return (
    <Wrap className={className}>
      <Move $offset={current}>
        {countArray.map((_, index) => (
          <Point key={index}>
            <HalfCircleLeft $isFocus={current === index} $isRed={isRed} />
            <MiddleExpand $isFocus={current === index} $isRed={isRed} />
            <HalfCircleRight $isFocus={current === index} $isRed={isRed} />
          </Point>
        ))}
      </Move>
    </Wrap>
  );
};

export default SwipeReperes;
